import { useLocalStorageState } from "~/hooks/use-local-storage-state";

const AI_CHAT_STORAGE_KEY = "istari-ai-chat-enabled";

export function useAiChatToggle() {
  const [isAiChatEnabled, setAiChatEnabled] = useLocalStorageState<boolean>(AI_CHAT_STORAGE_KEY, false);
  return { isAiChatEnabled, setAiChatEnabled };
}
